var _desc, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 282,
    viewBox: "0 0 367 282",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Prev") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-47 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prev"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "matrix(-1 0 0 1 414 35)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "matrix(-1 0 0 1 414 35)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "matrix(-1 0 0 1 414 35)",
    fill: "#FFFFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 207 141L 0 0L 0 282L 207 141Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M 367 141L 160 0L 160 282L 367 141Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M 319 21L 366 21L 366 260L 319 260L 319 21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.510ed5d17d68cad8b51966fa2bd4ce16.svg";
export { ForwardRef as ReactComponent };